import styled from "styled-components";

export const MyButton = styled.button`
  width: 300px;
  height: 52px;
  background: #4d9fc4;
  border-radius: 32px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: white;
  border: none;
  cursor: ${(props: { disabled: boolean }) =>
    props.disabled ? "not-allowed" : "pointer"};
  opacity: ${(props: { disabled: boolean }) => (props.disabled ? "0.5" : null)};
`;

export const IconImg = styled.img`
  margin-right: 8px;
  width: 16px;
  height: 16px;
`;
